$(document).ready(function() {
  // Initialize List.js sorting for lease companies table
  if ($('#lease-companies-sortable-table').length > 0) {
    var leaseCompaniesList = new List('lease-companies-sortable-table', {
      valueNames: [
        'lease-company-name',
        'object-lease-types'
      ],
      item: `<tr>
           <td class="lease-company-name"></td>
           <td class="object-lease-types"></td>
         </tr>`
    });
  }

  $(document).on('click', '#new_project_lease_company', function() {
    const project_id = $(this).data('project-id');

    $.ajax({
      url: '/project_lease_companies/new',
      method: 'GET',
      data: { project_id: project_id },
      dataType: 'script',
      success: function(res) {
      }
    });
  })

  $(document).on('shown.bs.modal', '#lease_company_modal', function () {
    initDateRangePicker();
    initSelect2();
  })

  function initSelect2() {
    $('.select2').select2({
      width: '100%',
      theme: 'bootstrap',
      placeholder: '選択してください',
      allowClear: true,
      language: {
        noResults: function () {
          return '見つかりません。';
        },
      },
    });
  }

  $(document).on('click', '.btn-edit-project-lease', function() {
    let project_lease_id = $(this).data('id');
    $.ajax({
      url: `/project_lease_companies/${project_lease_id}/edit`,
      method: 'GET',
      dataType: 'script',
      success: function(res){

      }
    })
  })

  function initDateRangePicker() {
    $('input.singledate').daterangepicker({
      locale: ja_date_locale,
      singleDatePicker: true,
      autoUpdateInput: false,
      autoApply: true,
    });

    $('input.singledate').on('apply.daterangepicker', function(ev, picker) {
      $(this).val(picker.startDate.format('YYYY/MM/DD'));
    });

    $('input.singledate').on('cancel.daterangepicker', function(ev, picker) {
      $(this).val('');
    });

    $('.datepicker-js').on('apply.daterangepicker', function(ev, picker) {
      $(this).val(picker.startDate.format('YYYY/MM/DD'));
      var clearIcon = $(this).closest('.input-clearable').find('.clear-icon');
      clearIcon.css('display', this.value ? 'inline' : 'none');
    });
  }


  $(document).on('change', '#project_lease_company_lease_company_id', function() {
    let lease_company_id = $(this).val();
    $.ajax({
      url: `/project_lease_companies/${lease_company_id}/load_data`,
      method: 'GET',
      dataType: 'json',
      success: function(res) {
        if(res.success) {
          $('#project_lease_company_object_lease_types_ids').prop('disabled', false);
          $('#project_lease_company_object_lease_types_ids').select2({
            width: '100%',
            theme: 'bootstrap',
            placeholder: '選択してください',
            allowClear: true,
            language: {
              noResults: function () {
                return '見つかりません。';
              },
            },
            data: res.data
          })
        }
      }
    })
  })

  $(document).on('shown.bs.modal', '#lease_company_modal', function () {
    $('.select2').select2({
      width: '100%',
      theme: 'bootstrap',
      placeholder: '選択してください',
      allowClear: true,
      language: {
        noResults: function () {
          return '見つかりません。';
        },
      },
      dropdownParent: $('#lease_company_modal')
    });

  })

  $(document).on('click', '#createProjectLease', function() {
    $(this).prop('disabled', true);
    let has_error = false;
    let lease_company_id =  $('#lease_company_modal').find('#project_lease_company_lease_company_id').val();
    if(lease_company_id == '') {
      $('#lease_company_modal').find('.error-msg').removeClass('d-none');
      has_error = true;
      $(this).prop('disabled', false);
    }

    let monthly_amount = $('#lease_company_modal').find('#project_lease_company_monthly_amount').val();

    if(!isNumber(monthly_amount)) {
      $('#monthly_amount_error').removeClass('d-none');
      has_error = true;
      $(this).prop('disabled', false);
    } else {
      $('#monthly_amount_error').addClass('d-none');
    }

    let period = $('#lease_company_modal').find('#project_lease_company_period').val();

    if(!period) {
      $('#period_error').removeClass('d-none');
      has_error = true;
      $(this).prop('disabled', false);
    }else{
      $('#period_error').addClass('d-none');
    }

    let interest_rate = $('#lease_company_modal').find('#project_lease_company_interest_rate').val();
    if(!isNumber(interest_rate)) {
      $('#interest_rate_error').removeClass('d-none');
      has_error = true;
      $(this).prop('disabled', false);
    }
    else if(interest_rate == 0){
      $('#interest_rate_error').removeClass('d-none').text('料率は0より大きい値を入力してください。');
      has_error = true;
      $(this).prop('disabled', false);
    } else {
      $('#interest_rate_error').addClass('d-none');
    }

    let objectLeaseTypesIds = $('#lease_company_modal').find('#project_lease_company_object_lease_types_ids').val();
    if(objectLeaseTypesIds.length == 0) {
      $('#object_lease_types_ids_error').removeClass('d-none');
      has_error = true;
      $(this).prop('disabled', false);
    }else{
      $('#object_lease_types_ids_error').addClass('d-none');
    }

    if(!has_error) {
      $('#lease_company_modal').find('.error-msg').addClass('d-none');
      $(this).closest('#lease_company_modal').find('form').submit();
    }
  })

  function isNumber(value) {
    value = value.replace(/,/g, '');
    return !isNaN(value) && !isNaN(parseFloat(value));
  }


  $(document).on('change', '.update_project_lease', function() {
    let field = $(this).data('field');
    let value;
    if (field == 'remaining_debt') {
      value = $(this).is(":checked");
    } else {
      value = $(this).val();
    }
    let id = $(this).data('id');

    $.ajax({
      url: `/project_lease_companies/${id}/update_data_field`,
      method: 'PUT',
      dataType: 'json',
      data: { field: field, value: value },
      success: function(res){
        alert(res.message);
        location.reload();
      }
    })
  })

  $(document).on('change', '.js-cost_price_lease, .js-amount-lease, .js-tax-rate-lease', function() {
    let price = getNumericValue($(this).closest('.parent-fields').find('.js-cost_price_lease').val().replace(/,/g, ''));
    let amount = getNumericValue($(this).closest('.parent-fields').find('.js-amount-lease').val().replace(/,/g, ''));
    let taxtRate = getNumericValue($(this).closest('.parent-fields').find('.js-tax-rate-lease').val().replace(/,/g, ''));
    update_price_lease(amount, price, taxtRate,  $(this).closest('.parent-fields').find('.js-sell_price_lease_company'));
  })

  $(document).on('change', '.js-sell_price_lease_company', function() {
    let sum = 0;

    $('.js-sell_price_lease_company').each(function() {
      let val = parseFloat($(this).val().replace(/,/g, '')) || 0;
      sum += val;
    });

    $('#total-lease-price').html(`￥ ${formatNumber(Math.round(sum))}`);
    $('#total-lease-price').attr('data-value', Math.round(sum));
    $('#total_tax_with_lease').html(`￥ ${formatNumber(Math.round(sum + $('#total-summary-tax').attr('data-value')))}`)
    let monthly_amount = $('#monthly_amount').data('value');
    $('#monthly_amount').html(`￥ ${formatNumber(Math.round(monthly_amount - sum)) || 0}`);
  })

  function update_price_lease(amount, price, taxtRate, object) {
    let priceIncludeTax = (price + (price * taxtRate))
    object.val(formatNumber(Math.round(amount * priceIncludeTax))).trigger('change');
  }

  function getNumericValue(value) {
    if (value !== undefined) {
        return _.toNumber(value.replace(/,/g, '')) || 0;
    }
    return 0;
  }

  function formatNumber(num) {
    if (num % 1 === 0) {
      return num.toLocaleString('en-US');
    } else {
      return num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  }

  $(document).on('click', '.btn-convert-estimate', function() {
    let id = $(this).data('id');
    let can_final = $(this).data('can-final');
    let has_final = $(this).data('has-final');
    let interest_rate = $(this).data('interest-rate');
    let total_sell_price = Math.round($(this).data('total-sell-price'));
    let total_cost_price = Math.round($(this).data('total-cost-price'));
    let total_lease_price = Math.round($(this).data('total-lease-price'));
    let unset_scheduled_cancellation_date = $(this).data('unset-scheduled-cancellation-date');
    let has_error = false;
    if(interest_rate == 0) {
      alert('リースの料率が登録されていません。料率を登録してください。');
      return false;
    }
    if(total_cost_price > (total_sell_price * 30 / 100)) {
      alert('工事費金額が商品名の合計金額の30％を超えています。');
      // return false;
    }
    if(total_lease_price > ((total_sell_price + total_cost_price) * 50 / 100)) {
      alert('旧物件の残債額が物件金額の50％を超えています。');
      return false;
    }
    if(unset_scheduled_cancellation_date) {
      alert('解約予定月が登録されていません。解約予定月を登録してください。');
      return false;
    }
    setTimeout(() => {
      if(!has_error) {
        if(has_final) {
          alert('もう一度確定しても大丈夫ですか。')
          setTimeout(function() {
              $.ajax({
                url: `/project_lease_companies/${id}/change_to_estimate_normal`,
                method: 'PUT',
                dataType: 'json',
                success: function(res) {
                  if (res.status) {
                    alert('最終見積成功');
                    const url = new URL(window.location.href);
                    url.searchParams.set('current_tab', 'estimate');
                    window.location.href = url.toString();
                  }
                }
              })
            }, 2000)
        } else {
          $.ajax({
            url: `/project_lease_companies/${id}/change_to_estimate_normal`,
            method: 'PUT',
            dataType: 'json',
            success: function(res) {
              if (res.status) {
                alert('最終見積成功');
                const url = new URL(window.location.href);
                url.searchParams.set('current_tab', 'estimate-tab');
                window.location.href = url.toString();
              }
            }
          })
        }
      } else {
        return false;
      }
    }, 300);

  })

  $(document).on('click', '.btn-save-estimate-lease', function(e) {
    let is_temporary = $(this).data('is-temporary');
    let isFinalConfirmed = $(this).data('is-final-confirmed');
    let interest_rate = $('#interest_rate').val();
    let total_sell_price = $('#total-sell-price').text().replace(/\￥/g, '').trim().replace(/,/g, '');
    let total_cost_price = $('#total-cost-price').text().replace(/\￥/g, '').trim().replace(/,/g, '');
    let total_lease_price = sum_total_lease_price();
    let summary_total = $('#summary-total').text().replace(/\￥/g, '').trim().replace(/,/g, '');
    let has_error = false;

    if(isFinalConfirmed) {
      has_error = true;
      alert('この受注案件の検収日が確定しているため、編集できません。');
    };

    if(interest_rate == 0) {
      has_error = true;
      alert('リースの料率が登録されていません。料率を登録してください。');
    };
    if (total_cost_price > (total_sell_price * 30 / 100) && !has_error) {
      // has_error = true;
      alert('工事費金額が商品名の合計金額の30％を超えています。');
    }

    if(total_lease_price > (summary_total * 50 / 100) && !has_error) {
      has_error = true;
      alert('旧物件の残債額が物件金額の50％を超えています。');
    }
    if(check_scheduled_cancellation_date() && !has_error) {
      has_error = true;
      alert('解約予定月が登録されていません。解約予定月を登録してください。');
    }
    if(!is_temporary && has_error) {
      return false;
    }
    const $btn = $(this);
    const $form = $('.form-estimate-sheet');
    if ($btn.prop('disabled') || $form.data('submitting')) {
      return false;
    }
    $btn.prop('disabled', true);
    $form.submit();
  })

  function sum_total_lease_price() {
    let total = 0;

    $('.parent-lease-fields').each(function () {
      const $row = $(this);
      const amount = parseFloat($row.find('.js-amount-lease').val().replace(/,/g, '')) || 0;
      const price = parseFloat($row.find('.js-cost_price_lease').val().replace(/,/g, '')) || 0;
      const subtotal = Math.round(amount * price);
      total += subtotal;
    });

    return total;
  }

  function check_scheduled_cancellation_date() {
    let found = false;

    $('.parent-lease-fields:visible').each(function() {
      // const checkbox = $(this).find('input.offset-lease[type="checkbox"]');
      const input = $(this).find('.scheduled_cancellation_date_field');
      const sell_price = $(this).find('.js-sell_price_lease_company').val();
      if ($.trim(input.val()) === '' && sell_price != '' && sell_price > 0) {
        found = true;
        return true;
      }
    });

    return found;
  }

  $('.check-target_audience').on('change', function() {
    if (this.checked) {
      $('.check-target_audience').not(this).prop('checked', false);
    }
  });


  //Handle month-year-picker
  $(document).on('cocoon:after-insert', function(e, insertedItem) {
    customMonthYearPicker(insertedItem);
  });

  customMonthYearPicker($(document));

  function customMonthYearPicker(container) {
    container.find('.month-year-picker').each(function() {
      const obj = $(this);
      $(obj).daterangepicker({
        locale: ja_date_locale_month_year,
        singleDatePicker: true,
        autoUpdateInput: false,
        showDropdowns: true,
        parentEl: $(obj).parent(),
        isCustomDate: function() {
        $('.daterangepicker:visible .single.drp-calendar').css("width", "100%");
        $('.daterangepicker:visible .single .monthselect').css({
          "width": "43%",
          "float": 'right'
        });
        if($('.daterangepicker:visible .single .datepicker-year').length == 0){
          $('.daterangepicker:visible .single .monthselect').after("<div class='datepicker-year', style='float:right;'>年</div>");
        }
        $('.daterangepicker:visible .yearselect').css({
          "width": "43%",
          "float": 'right'
        });
        $('.daterangepicker:visible .single .table-condensed > tbody').hide();
        $('.daterangepicker:visible .single .table-condensed > thead').children('tr').eq(1).hide();
      }
      });

      $(obj).on('hide.daterangepicker', function (ev, picker) {
        let month = parseInt($(this).parent().find('.daterangepicker .monthselect :selected').val()) + 1;
        let year = $(this).parent().find('.daterangepicker .yearselect :selected').val();
        let format = $(this).data('format') || 'YYYY/MM/DD';
        $(this).data('daterangepicker').setStartDate(year + '/' + month);
        $(this).val(picker.startDate.format(format));
        var clearIcon = $(this).closest('.input-clearable').find('.clear-icon');
        clearIcon.css('display', this.value ? 'inline' : 'none');
        if($(this).closest('#bill_sheet_month').length > 0) {
          $('#choose-bill-sheet-month-submit').prop('disabled', this.value ? false : true);
        }
      });

      $(obj).on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
      });

      $(obj).on('show.daterangepicker', function (ev, picker) {
        $('.daterangepicker:visible .single.drp-calendar').css("width", "100%");
        $('.daterangepicker:visible .single .monthselect').css({
          "width": "43%",
          "float": 'right'
        });
        if($('.daterangepicker:visible .single .datepicker-year').length == 0){
          $('.daterangepicker:visible .single .monthselect').after("<div class='datepicker-year', style='float:right;'>年</div>");
        }
        $('.daterangepicker:visible .single .yearselect').css({
          "width": "43%",
          "float": 'right'
        });
        $('.daterangepicker:visible .single .table-condensed > tbody').hide();
        $('.daterangepicker:visible .single .table-condensed > thead').children('tr').eq(1).hide();
      });
    });
  }

  // Delete project lease company functionality
  $(document).on('click', '.btn-delete-project-lease', function(e) {
    e.preventDefault();

    if ($(this).is(':disabled')) {
      return false;
    }

    const leaseCompanyId = $(this).data('id');

    if (confirm('このリース会社を削除してもよろしいですか？')) {
      $.ajax({
        url: `/project_lease_companies/${leaseCompanyId}`,
        method: 'DELETE',
        dataType: 'json',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        success: function(response) {
          if (response.status === false) {
            alert(response.message);
          } else {
            location.reload();
          }
        },
        error: function() {
          location.reload();
        }
      });
    }
  });


})
